import { render, staticRenderFns } from "./GeneralSettingsCustomer.vue?vue&type=template&id=527409da&"
import script from "./GeneralSettingsCustomer.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports